import { Box, Flex } from 'app/components/design-system-components'
import { ToolTip } from 'app/components/design-system-components/Tooltip'
import * as Form from 'app/components/forms/forms'
import theme from 'app/match/applicationReportPDF/assets/theme'
import {
  SMART_DOCS_FIELD_SETTING,
  SMART_DOCS_IMPORTANCE_OPTIONS,
  SMART_DOCS_SENSITIVITY_OPTIONS,
} from 'app/sm/team_viewing_preference/AITools/constants'

function SmartDocsFieldSettings({
  field,
  value,
  onChange,
  isActionDisabled = false,
  isFieldDisabled = false,
}) {
  const controlDisabled = isActionDisabled || isFieldDisabled
  const dependentControlsDisabled = controlDisabled || !Boolean(value?.enabled)

  const onEnabledChange = (event) =>
    onChange(
      field.fieldKey,
      SMART_DOCS_FIELD_SETTING.ENABLED,
      event.target.checked,
    )

  const onImportanceChange = ({ value: importance }) =>
    onChange(field.fieldKey, SMART_DOCS_FIELD_SETTING.IMPORTANCE, importance)

  const onSensitivityChange = ({ value: sensitivity }) =>
    onChange(field.fieldKey, SMART_DOCS_FIELD_SETTING.SENSITIVITY, sensitivity)

  return (
    <Box mb={5}>
      <Flex alignItems="center">
        <Form.CheckBoxGeneral
          id={`smartdocs-${field.fieldKey}-enabled`}
          label={field.label}
          checked={!isFieldDisabled && Boolean(value?.enabled)}
          onChange={onEnabledChange}
          componentClassName="mt0"
          eventProcessedByComponent
          disabled={controlDisabled}
          showDisabledGrey={controlDisabled}
        />
        <ToolTip
          content={field.tooltip}
          toolTipID={`smartdocs-${field.fieldKey}`}
        />
      </Flex>

      <Flex alignItems="flex-start" flexWrap="wrap" mt={3}>
        <Box width="260px" mr={4} mb={4}>
          <Box
            as="label"
            htmlFor={`smartdocs-${field.fieldKey}-importance`}
            display="block"
            mb={2}
            fontSize={theme.fontSizes.pSmall12}
            color={theme.colors.gray500}
            fontWeight={600}
            style={{
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
            }}
          >
            Importance
          </Box>
          <Form.Dropdown
            id={`smartdocs-${field.fieldKey}-importance`}
            label="Select importance"
            value={value?.importance}
            options={SMART_DOCS_IMPORTANCE_OPTIONS}
            onChange={onImportanceChange}
            useLabelValueOptions
            selectIsDisabled={dependentControlsDisabled}
            componentClass="mt0"
          />
        </Box>
        <Box width="260px" mb={4}>
          <Box
            as="label"
            htmlFor={`smartdocs-${field.fieldKey}-sensitivity`}
            display="block"
            mb={2}
            fontSize={theme.fontSizes.pSmall12}
            color={theme.colors.gray500}
            fontWeight={600}
            style={{
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
            }}
          >
            Sensitivity
          </Box>
          <Form.Dropdown
            id={`smartdocs-${field.fieldKey}-sensitivity`}
            label="Select sensitivity"
            value={value?.sensitivity}
            options={SMART_DOCS_SENSITIVITY_OPTIONS}
            onChange={onSensitivityChange}
            useLabelValueOptions
            selectIsDisabled={dependentControlsDisabled}
            componentClass="mt0"
          />
        </Box>
      </Flex>
    </Box>
  )
}

export default SmartDocsFieldSettings
